import { PageInfo } from '../../../admin/user/shared/models/pageInfoModel';
import { SortInfo } from '../../../admin/user/shared/models/sortInfoModel';

export class LobbyDetailViewHeaderDataResponseModel {
    totalRecords: number = 0;
    appointmentsCompleted: number = 0;
    walkinsCompleted: number = 0;
    abandons: number = 0;
    noShows: number = 0;
    abandonsAsPercentOfTotalRecords: number = 0;
    avgWaitTime: number = 0;
    avgAssistTime: number = 0;
    earliestOpenHour: number = 0;
    latestCloseHour: number = 0;
    avgWaitTimeFormatted: string = '';
    avgAssistTimeFormatted: string = '';
    constructor(){}
}

export interface LobbyDetailViewTrafficAndWaitByMonthResponseModel {
  monthNumber: number;
  monthName: string;
  avgAppointmentsCompleted: number;
  avgWalkinsCompleted: number;
  avgWaitTime: number;
  avgLWA: number;
}

export interface LobbyDetailViewTrafficAndWaitByWeekResponseModel {
  weekNumber: string;
  avgAppointmentsCompleted: number;
  avgWalkinsCompleted: number;
  avgWaitTime: number;
  avgLWA: number;
}

export interface LobbyDetailViewTrafficAndWaitByDayResponseModel {
  dayNumber: number;
  dayName: string;
  avgAppointmentsCompleted: number;
  avgWalkinsCompleted: number;
  avgWaitTime: number;
  avgLWA: number;
}

export interface LobbyDetailViewTrafficAndWaitByHourResponseModel {
  hourNumber: string;
  hourNumberAsNumber: number;
  avgAppointmentsCompleted: number;
  avgWalkinsCompleted: number;
  avgLWA: number;
  avgWaitTime: number;
}

export interface LobbyDetailViewTrafficAndWaitByLocationResponseModel {
  locationCode: string;
  locationName: string;
  totalAppointmentsCompleted: number;
  totalWalkinsCompleted: number;
  avgWaitTime: number;
  totalLWA: number;
}

export interface LobbyDetailViewProductsAndServicesByLocationResponseModel {
  locationCode: string;
  locationName: string;
  productOrServiceType: string;
  totalProvided: number;
}

export interface LobbyDetailViewProductsAndServicesByEmployeeResponseModel {
  code: string;
  productOrServiceType: string;
  totalProvided: number;
  hoverText: string;
  employeeName: string;
}

export interface LobbyDetailViewAvgAssistTimeByLocationResponseModel{
  locationCode: string;
  locationName: string;
  productOrServiceType: string;
  avgAssistTime: number;
  avgTimeStandard: number;
}

export interface LobbyDetailViewAvgAssistTimeByEmployeeResponseModel{
  code: string;
  productOrServiceType: string;
  avgAssistTime: number;
  avgTimeStandard: number;
  employeeName: string;
  testField: number;
}

export interface LobbyDetailViewAvgAssistTimeByProductOrServiceResponseModel{
  productOrServiceCode: string;
  productServiceName: string;
  productOrServiceType: string;
  avgAssistTime: number;
  avgTimeStandard: number;
}

export interface LobbyDetailViewProductsAndServicesProvidedResponseModel{
  productServiceCode: string;
  productServiceName: string;
  productOrServiceType: string;
  numberProvided: number;
}

export class LobbyDataGridDataModel{
  pageInfo: PageInfo;
  sortInfo: SortInfo;
  gridData: any;
  constructor() {
    this.pageInfo = new PageInfo();
    this.pageInfo.Page = 1;
    this.sortInfo = new SortInfo();
    this.sortInfo.SortColumn = "LobbyEntryId";
    this.sortInfo.sortDirection = 1;
    }
  }

  export class SignInOutDetailGridDataModel{
    pageInfo: PageInfo;
    sortInfo: SortInfo;
    gridData: any;
    constructor() {
      this.pageInfo = new PageInfo();
      this.pageInfo.Page = 1;
      this.sortInfo = new SortInfo();
      this.sortInfo.SortColumn = "Location";
      this.sortInfo.sortDirection = 1;
      }
    }

  export interface SignInOutDetailResponseModel{
    locationName: string;
    employeeName: string;
    staffSignInDate: string;
    staffSignInTime: string;
    staffSignOutDate: string;
    signOutReason: string;
    interactionTimeInSeconds: number;
    idleTimeInSeconds: number;
    signedInTimeInSeconds: number;
    signedOutTimeInSeconds: number;
    productivityPercentage: number;
    interactionTime: string;
    idleTime: string;
    signedOutTime: string;
    productivityPercentageStr: string;
  }

  export class LobbyDetailViewAllChartsDataResponseModel{
    headerData: Array<LobbyDetailViewHeaderDataResponseModel>;
    productsAndServicesDataByEmployee: Array<LobbyDetailViewProductsAndServicesByEmployeeResponseModel>;
    avgAssistTimeDataByEmployee: Array<LobbyDetailViewAvgAssistTimeByEmployeeResponseModel>;
    productsAndServicesProvided: Array<LobbyDetailViewProductsAndServicesProvidedResponseModel>;
    avgAssistTimeDataByProductOrService: Array<LobbyDetailViewAvgAssistTimeByProductOrServiceResponseModel>;
    productsAndServicesDataByLocation: Array<LobbyDetailViewProductsAndServicesByLocationResponseModel>;
    avgAssistTimeDataByLocation: Array<LobbyDetailViewAvgAssistTimeByLocationResponseModel>;
    trafficAndWaitDataByLocation: Array<LobbyDetailViewTrafficAndWaitByLocationResponseModel>;
    trafficAndWaitDataByWeekOfMonth: Array<LobbyDetailViewTrafficAndWaitByWeekResponseModel>;
    trafficAndWaitDataByDayOfWeek: Array<LobbyDetailViewTrafficAndWaitByDayResponseModel>;
    trafficAndWaitDataByMonth: Array<LobbyDetailViewTrafficAndWaitByMonthResponseModel>;
    trafficAndWaitDataByHour: Array<LobbyDetailViewTrafficAndWaitByHourResponseModel>;
    staffSignInOutDetails: SignInOutDetailGridDataModel;

    constructor() {
      this.headerData = new Array<LobbyDetailViewHeaderDataResponseModel>();
      this.productsAndServicesDataByEmployee = new Array<LobbyDetailViewProductsAndServicesByEmployeeResponseModel>();
      this.avgAssistTimeDataByEmployee = new Array<LobbyDetailViewAvgAssistTimeByEmployeeResponseModel>();
      this.productsAndServicesProvided = new Array<LobbyDetailViewProductsAndServicesProvidedResponseModel>();
      this.avgAssistTimeDataByProductOrService = new Array<LobbyDetailViewAvgAssistTimeByProductOrServiceResponseModel>();
      this.productsAndServicesDataByLocation = new Array<LobbyDetailViewProductsAndServicesByLocationResponseModel>();
      this.avgAssistTimeDataByLocation = new Array<LobbyDetailViewAvgAssistTimeByLocationResponseModel>();
      this.trafficAndWaitDataByLocation = new Array<LobbyDetailViewTrafficAndWaitByLocationResponseModel>();
      this.trafficAndWaitDataByWeekOfMonth = new Array<LobbyDetailViewTrafficAndWaitByWeekResponseModel>();
      this.trafficAndWaitDataByDayOfWeek = new Array<LobbyDetailViewTrafficAndWaitByDayResponseModel>();
      this.trafficAndWaitDataByMonth = new Array<LobbyDetailViewTrafficAndWaitByMonthResponseModel>();
      this.trafficAndWaitDataByHour = new Array<LobbyDetailViewTrafficAndWaitByHourResponseModel>();
      this.staffSignInOutDetails = new SignInOutDetailGridDataModel;
      }
  }





